import React from "react";

const SVG = ({
  width = "100%",
  className = "",
  viewBox = "0 0 6 6",
  color = "#8F8E9F",
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h6v6H0z" />
      <path
        d="M5.03.75H.972a.728.728 0 0 0-.626 1.093l2.03 3.387a.73.73 0 0 0 1.246.001l2.028-3.385A.728.728 0 0 0 5.029.75z"
        fill={color}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default SVG;
